module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACZSURBVHgB7dGxDcIwEIXhd5YSiY4RGMEN7tmIDTiYgBHYBFFT4A1ghHRICc4joY+xpUAR5W8sS6evuAPmfppVLpGZGcaeq1LCzR3CDmOAXhcPsr2A1Fw02lrrk9u/OB3UILEGOPYvyW3s+kmg1doWYs4EKrDdeJVqaFZSsc+nw65a+ti8jIlFwX5PhYR7DvY1p41217WY+2tvBBRRtnpN9pkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/pblCourse/chevronRight.png
// module id = 5Mgf
// module chunks = 4